module.exports = __webpack_public_path__ + "img/11.a2276a76.png";